module.exports = __webpack_public_path__ + "media/assets/icons/fitness-centre-15-b293fcd42c46a8397339b687a7b7d81e.svg";